import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RiderService } from 'app/services';
import { MerchantApprovedRejectProductComponent } from 'app/merchant';

@Component({
    selector: 'merchant-reject-product',
    templateUrl: './merchant-reject-product.component.html',
    styleUrls: ['./merchant-reject-product.component.scss',
        '../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class MerchantRejectProductComponent implements OnInit {
    public displayModalReject: boolean = false;
    @Input()
    set _displayModalReject(value: boolean) {
        this.displayModalReject = value;
    }

    @Input() public merchantApprovedRejectProductComponent!: MerchantApprovedRejectProductComponent;

    public rejectOptions: any = [
        { label: 'Blurry', value: 'Blurry' },
        { label: 'Not match', value: 'Not match' },
    ];
    public rejectValue: string = '';
    public loadingReject: boolean = false;

    @Output() changedDisplayModalMerchantRejectProductEmit = new EventEmitter<any>();
    changeDisplayModalMerchantRejectProduct(increased: any) {
        this.changedDisplayModalMerchantRejectProductEmit.emit(increased);
    }

    constructor(
        private messageService: MessageService,
        private riderService: RiderService
    ) { }

    ngOnInit(): void { }

    saveReject() {
        this.changeDisplayModalMerchantRejectProduct({ displayModal: false, rejectValue: this.rejectValue, isSaveBtn: true });
    }

    cancel() {
        this.changeDisplayModalMerchantRejectProduct({ displayModal: this.displayModalReject, rejectValue: this.rejectValue, isSaveBtn: false });
    }
}
